import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { NOTE } from "@/utils/constants";

interface SectionModalProps {
  conf: string[];
  addSection(key: string): void;
}

const SectionModal: React.FC<SectionModalProps> = ({ conf, addSection }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="h-10 w-fit float-left px-5 dark:text-white text-sm border-gray-25 dark:border-gray-600 hover:border-gray-25 dark:hover:border-gray-600 hover:bg-gray-25 dark:hover:bg-gray-800 "
        >
          Add Section
        </Button>
      </DialogTrigger>
      <DialogContent className="w-full sm:max-w-[600px] dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle>Add Section</DialogTitle>
        </DialogHeader>
        <div className="py-4 max-h-[70vh] overflow-auto">
          {(conf || []).map((key) => {
            return (
              <div key={key}>
                <div
                  onClick={() => {
                    addSection(key);
                    setIsOpen(false);
                  }}
                  className="dark:text-white hover:bg-gray-25 dark:hover:bg-gray-800 flex items-center cursor-pointer py-[6px] px-2"
                >
                  {NOTE[key] as string}
                </div>
                <hr />
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SectionModal;
